import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './authorize.service';

/**
 * Sperrt Bereiche für den reinen Vorarbeiter (nur Lager + Ticketsystem). Wer als
 * Feld-Vorarbeiter angemeldet ist, wird auf seine Einsätze umgeleitet, statt z.B.
 * die Wartung zu sehen (die sonst nur hinter dem AuthGuard liegt).
 */
@Injectable({ providedIn: 'root' })
export class FieldVorarbeiterBlockGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): boolean {
    if (this.authService.isFieldVorarbeiter()) {
      this.router.navigate(['/stammkunden/meine-einsaetze']);
      return false;
    }
    return true;
  }
}
